import React, { useState } from 'react';
import { Helmet } from 'react-helmet';
import FaqSection from './components/FaqSection';
import { Link } from 'react-router-dom';

// --- Data for 50 attractions with pre-defined mapUrls ---
// --- ✨ Data expanded to a huge list of attractions from the Timeout guide ---
const allAttractions = [
    {
        name: "The Tower of London",
        description: "A historic castle offering gruesome tales, hands-on activities, and a dazzling look at the Crown Jewels.",
        imageUrl: "https://media.timeout.com/images/103315915/750/422/image.jpg",
        mapUrl: "https://www.google.com/maps/search/?api=1&query=The+Tower+of+London"
    },
    {
        name: "The London Eye",
        description: "Step into one of its spaceship-like pods to take in sweeping vistas of the city from high above the Thames.",
        imageUrl: "https://media.timeout.com/images/106133938/750/422/image.jpg",
        mapUrl: "https://www.google.com/maps/search/?api=1&query=The+London+Eye"
    },
    {
        name: "Buckingham Palace",
        description: "A chance to see world-famous art, glimpse regal opulence and get inside Her Majesty’s headquarters during the summer tours.",
        imageUrl: "https://media.timeout.com/images/103938231/750/422/image.jpg",
        mapUrl: "https://www.google.com/maps/search/?api=1&query=Buckingham+Palace"
    },
    {
        name: "The National Gallery",
        description: "A huge, free art museum on Trafalgar Square. Perfect for seeing Van Gogh’s ‘Sunflowers’ or wandering the entire collection.",
        imageUrl: "https://media.timeout.com/images/106212911/750/422/image.jpg",
        mapUrl: "https://www.google.com/maps/search/?api=1&query=The+National+Gallery"
    },
    {
        name: "St Paul's Cathedral",
        description: "Sir Christopher Wren’s architectural marvel, which has survived 12 monarchs and two world wars. Famous for its Whispering Gallery.",
        imageUrl: "https://media.timeout.com/images/106198624/750/422/image.jpg",
        mapUrl: "https://www.google.com/maps/search/?api=1&query=St+Paul's+Cathedral"
    },
    {
        name: "Westminster Abbey",
        description: "A stunning Gothic abbey that has hosted every British coronation since 1066. See the tombs of 17 monarchs and historical figures.",
        imageUrl: "https://media.timeout.com/images/106133925/750/422/image.jpg",
        mapUrl: "https://www.google.com/maps/search/?api=1&query=Westminster+Abbey"
    },
    {
        name: "The British Museum",
        description: "The world's first public museum, showcasing global artifacts that document human culture, including the Rosetta Stone.",
        imageUrl: "https://media.timeout.com/images/106198638/750/422/image.jpg",
        mapUrl: "https://www.google.com/maps/search/?api=1&query=The+British+Museum"
    },
    {
        name: "Warner Bros. Studio Tour London",
        description: "A magical behind-the-scenes look at the sets, props, and costumes from the iconic Harry Potter films.",
        imageUrl: "https://media.timeout.com/images/106198628/750/422/image.jpg",
        mapUrl: "https://www.google.com/maps/search/?api=1&query=Warner+Bros.+Studio+Tour+London"
    },
    {
        name: "The View from The Shard",
        description: "A viewing platform at the top of London's tallest skyscraper, offering stunning 360-degree views of the city.",
        imageUrl: "https://media.timeout.com/images/102514967/750/422/image.jpg",
        mapUrl: "https://www.google.com/maps/search/?api=1&query=The+View+from+The+Shard"
    },
    {
        name: "Kew Gardens",
        description: "Over 300 acres to explore, filled with flora, fauna, exotic greenhouses, a treetop walkway, and the world's largest Victorian glasshouse.",
        imageUrl: "https://media.timeout.com/images/106212912/750/422/image.jpg",
        mapUrl: "https://www.google.com/maps/search/?api=1&query=Kew+Gardens"
    },
    {
        name: "Tower Bridge",
        description: "There’s more to this ornate Victorian bridge than something cool to look at: you can actually venture inside the engine rooms and glass walkway.",
        imageUrl: "https://media.timeout.com/images/106198625/750/422/image.jpg",
        mapUrl: "https://www.google.com/maps/search/?api=1&query=Tower+Bridge"
    },
    {
        name: "Shakespeare's Globe",
        description: "A painstakingly accurate recreation of the kind of theatre Shakespeare would have written all his plays for. Get groundling tickets for a lively experience.",
        imageUrl: "https://media.timeout.com/images/102909256/750/422/image.jpg",
        mapUrl: "https://www.google.com/maps/search/?api=1&query=Shakespeare's+Globe"
    },
    {
        name: "Tate Modern",
        description: "A riverside icon dedicated to modern and contemporary art, based in what was the Bankside power station. The permanent collection is always free.",
        imageUrl: "https://media.timeout.com/images/106198640/750/422/image.jpg",
        mapUrl: "https://www.google.com/maps/search/?api=1&query=Tate+Modern"
    },
    {
        name: "London Zoo",
        description: "This Regent’s Park landmark does world-class animal welfare work, creating carefully designed settings for creatures from gorillas to tigers.",
        imageUrl: "https://media.timeout.com/images/106198645/750/422/image.jpg",
        mapUrl: "https://www.google.com/maps/search/?api=1&query=London+Zoo"
    },
    {
        name: "Hyde Park",
        description: "A massive central London park. Wander its vast greenery, take a dip in the Serpentine Lake, or simply enjoy a picnic.",
        imageUrl: "https://media.timeout.com/images/106198673/750/422/image.jpg",
        mapUrl: "https://www.google.com/maps/search/?api=1&query=Hyde+Park,+London"
    },
    {
        name: "Natural History Museum",
        description: "The magnificent South Kensington home of around 80 million plant, animal, fossil, rock and mineral specimens. And it's free!",
        imageUrl: "https://media.timeout.com/images/106198668/750/422/image.jpg",
        mapUrl: "https://www.google.com/maps/search/?api=1&query=Natural+History+Museum,+London"
    },
    {
        name: "Borough Market",
        description: "Located near London Bridge, this is an upmarket foodie heaven of markets, restaurants, bars and pubs. Go on an empty stomach!",
        imageUrl: "https://media.timeout.com/images/106198671/750/422/image.jpg",
        mapUrl: "https://www.google.com/maps/search/?api=1&query=Borough+Market"
    },
    {
        name: "The Science Museum",
        description: "An incredible, free-to-enter, hands-on museum with seven floors of entertaining and educational exhibits, including the Apollo 10 command module.",
        imageUrl: "https://media.timeout.com/images/106198657/750/422/image.jpg",
        mapUrl: "https://www.google.com/maps/search/?api=1&query=The+Science+Museum,+London"
    },
    {
        name: "Shrek’s Adventure! London",
        description: "An interactive tour that starts with a breathtaking 4D ride before you crash-land in a certain ogre’s swamp.",
        imageUrl: "https://media.timeout.com/images/102886003/750/422/image.jpg",
        mapUrl: "https://www.google.com/maps/search/?api=1&query=Shrek’s+Adventure!+London"
    },
    {
        name: "The London Dungeon",
        description: "A tour of London’s nastiest historical moments, with gooey props and gruesomely costumed actors.",
        imageUrl: "https://media.timeout.com/images/100640259/750/422/image.jpg",
        mapUrl: "https://www.google.com/maps/search/?api=1&query=The+London+Dungeon"
    },
    {
        name: "The Houses of Parliament",
        description: "The seat of British democracy. Take an audio tour through the House of Lords and House of Commons to bring the building to life.",
        imageUrl: "https://media.timeout.com/images/100672913/750/422/image.jpg",
        mapUrl: "https://www.google.com/maps/search/?api=1&query=The+Houses+of+Parliament"
    },
    {
        name: "The Sea Life London Aquarium",
        description: "The home of sea creatures from all over the world, from Pacific nurse sharks to Antarctic penguins.",
        imageUrl: "https://media.timeout.com/images/103795238/750/422/image.jpg",
        mapUrl: "https://www.google.com/maps/search/?api=1&query=Sea+Life+London+Aquarium"
    },
    {
        name: "Hampton Court Palace",
        description: "A resplendent palace with plush grounds, a famous Royal Maze, and the Magic Garden adventure playground.",
        imageUrl: "https://media.timeout.com/images/106261863/750/422/image.jpg",
        mapUrl: "https://www.google.com/maps/search/?api=1&query=Hampton+Court+Palace"
    },
    {
        name: "Royal Opera House",
        description: "Covent Garden’s grand old opera house. Visiting for a performance doesn’t have to set you back a ton of cash.",
        imageUrl: "https://media.timeout.com/images/106212914/750/422/image.jpg",
        mapUrl: "https://www.google.com/maps/search/?api=1&query=Royal+Opera+House"
    },
    {
        name: "Wembley Stadium",
        description: "The venue where England won the World Cup in 1966. Take the tour to feel the atmosphere in the players’ tunnel.",
        imageUrl: "https://media.timeout.com/images/103558232/750/422/image.jpg",
        mapUrl: "https://www.google.com/maps/search/?api=1&query=Wembley+Stadium"
    },
    {
        name: "Up at The O2",
        description: "Get your adorable climbing onesie on and ascend to the roof for incredible 360-degree views over London.",
        imageUrl: "https://media.timeout.com/images/101417899/750/422/image.jpg",
        mapUrl: "https://www.google.com/maps/search/?api=1&query=Up+at+The+O2"
    },
    {
        name: "Kensington Palace",
        description: "This was home to Queen Victoria in her youth, then sassy Princess Margaret and classy Princess Diana. Now a visitor magnet with tranquil gardens.",
        imageUrl: "https://media.timeout.com/images/106133927/750/422/image.jpg",
        mapUrl: "https://www.google.com/maps/search/?api=1&query=Kensington+Palace"
    },
    {
        name: "Big Ben",
        description: "The world's most celebrated clock. Renovations were recently completed, meaning it’s in better nick than ever.",
        imageUrl: "https://media.timeout.com/images/103014910/750/422/image.jpg",
        mapUrl: "https://www.google.com/maps/search/?api=1&query=Big+Ben"
    },
    {
        name: "Churchill War Rooms",
        description: "The secret underground bunker where Churchill directed WWII. See the rooms just as they were left after 1945.",
        imageUrl: "https://media.timeout.com/images/106198634/750/422/image.jpg",
        mapUrl: "https://www.google.com/maps/search/?api=1&query=Churchill+War+Rooms"
    },
    {
        name: "Queen Elizabeth Olympic Park",
        description: "The huge park created for the 2012 Olympics. Go for a swim at the Aquatics Centre, BMX at the VeloPark, or just stroll the beautiful grounds.",
        imageUrl: "https://media.timeout.com/images/106198631/750/422/image.jpg",
        mapUrl: "https://www.google.com/maps/search/?api=1&query=Queen+Elizabeth+Olympic+Park"
    },
    {
        name: "Thames RIB Experience",
        description: "A high-speed inflatable boat that will have you zooming up and down the river. The fastest, most thrilling way to see the sights.",
        imageUrl: "https://media.timeout.com/images/102072345/750/422/image.jpg",
        mapUrl: "https://www.google.com/maps/search/?api=1&query=Thames+RIB+Experience"
    },
    {
        name: "The V&A",
        description: "One of the greatest collections of decorative art, design, and fashion in the world. Admission is free, except for special exhibitions.",
        imageUrl: "https://media.timeout.com/images/106190402/750/422/image.jpg",
        mapUrl: "https://www.google.com/maps/search/?api=1&query=Victoria+and+Albert+Museum"
    },
    {
        name: "Madame Tussauds",
        description: "Come face-to-wax-face with over 150 lifelike models of contemporary stars and historic icons.",
        imageUrl: "https://media.timeout.com/images/106214067/750/422/image.jpg",
        mapUrl: "https://www.google.com/maps/search/?api=1&query=Madame+Tussauds+London"
    },
    {
        name: "National Theatre",
        description: "Arguably the greatest theatre in the world. Take your pick of entertainment from the three performance spaces on the South Bank.",
        imageUrl: "https://media.timeout.com/images/106198635/750/422/image.jpg",
        mapUrl: "https://www.google.com/maps/search/?api=1&query=National+Theatre"
    },
    {
        name: "The Royal Albert Hall",
        description: "Most famously associated with the Proms, its prestigious hall has played host to all kinds of music, theatre and comedy.",
        imageUrl: "https://media.timeout.com/images/106198637/750/422/image.jpg",
        mapUrl: "https://www.google.com/maps/search/?api=1&query=Royal+Albert+Hall"
    },
    {
        name: "Somerset House",
        description: "An elegant landmark and cultural hub that hosts art exhibitions, gigs, and an alfresco cinema in its courtyard.",
        imageUrl: "https://media.timeout.com/images/100683771/750/422/image.jpg",
        mapUrl: "https://www.google.com/maps/search/?api=1&query=Somerset+House"
    },
    {
        name: "Kew Palace",
        description: "The favoured residence of George III, located within Kew Gardens. Discover an often-forgotten treasure.",
        imageUrl: "https://media.timeout.com/images/106212916/750/422/image.jpg",
        mapUrl: "https://www.google.com/maps/search/?api=1&query=Kew+Palace"
    },
    {
        name: "The Cutty Sark",
        description: "The world’s last surviving tea clipper. Experience life on board and see the intricate craftsmanship used in its creation.",
        imageUrl: "https://media.timeout.com/images/106198641/750/422/image.jpg",
        mapUrl: "https://www.google.com/maps/search/?api=1&query=Cutty+Sark"
    },
    {
        name: "London Transport Museum",
        description: "A vast museum full of real relics from the bygone ages of London transport, where there’s always a bus or train to hop on.",
        imageUrl: "https://media.timeout.com/images/106198644/750/422/image.jpg",
        mapUrl: "https://www.google.com/maps/search/?api=1&query=London+Transport+Museum"
    },
    {
        name: "Highgate Cemetery",
        description: "A beautiful, crumbling north London cemetery. Find the graves of Karl Marx, Christina Rossetti and other famous figures.",
        imageUrl: "https://media.timeout.com/images/106212920/750/422/image.jpg",
        mapUrl: "https://www.google.com/maps/search/?api=1&query=Highgate+Cemetery"
    },
    {
        name: "The South Bank",
        description: "A buzzing open space and cultural nucleus lined with exciting galleries, theatres and attractions.",
        imageUrl: "https://media.timeout.com/images/103947484/750/422/image.jpg",
        mapUrl: "https://www.google.com/maps/search/?api=1&query=South+Bank,+London"
    },
    {
        name: "The British Library",
        description: "A working resource for printed and sound archives. See a scribbled page of Beatles songwriting or a Leonardo da Vinci notebook.",
        imageUrl: "https://media.timeout.com/images/106133933/750/422/image.jpg",
        mapUrl: "https://www.google.com/maps/search/?api=1&query=The+British+Library"
    },
    {
        name: "Trafalgar Square",
        description: "Pose with the lions, fountains and the latest modern art installation on the Fourth Plinth.",
        imageUrl: "https://media.timeout.com/images/106212923/750/422/image.jpg",
        mapUrl: "https://www.google.com/maps/search/?api=1&query=Trafalgar+Square"
    },
    {
        name: "Greenwich Royal Observatory",
        description: "See where the Greenwich Meridian Line is marked out, from which point the world’s time zones are measured.",
        imageUrl: "https://media.timeout.com/images/106198675/750/422/image.jpg",
        mapUrl: "https://www.google.com/maps/search/?api=1&query=Royal+Observatory+Greenwich"
    },
    {
        name: "Design Museum",
        description: "A trove of the world’s finest design, covering a wealth of disciplines, from architecture and fashion to graphics and products.",
        imageUrl: "https://media.timeout.com/images/103641834/750/422/image.jpg",
        mapUrl: "https://www.google.com/maps/search/?api=1&query=Design+Museum,+London"
    },
    {
        name: "HMS Belfast",
        description: "A grey warship moored close to Tower Bridge. Explore all levels of the boat, from the engine room to the action stations on deck.",
        imageUrl: "https://media.timeout.com/images/106202904/750/422/image.jpg",
        mapUrl: "https://www.google.com/maps/search/?api=1&query=HMS+Belfast"
    },
    {
        name: "Alexandra Palace",
        description: "Known as ‘The People’s Palace’, its altitude rewards visitors with spectacular views over central London from its 190 acres of parkland.",
        imageUrl: "https://media.timeout.com/images/106199097/750/422/image.jpg",
        mapUrl: "https://www.google.com/maps/search/?api=1&query=Alexandra+Palace"
    },
    {
        name: "Regent's Park",
        description: "A verdant 410 acres of lush, open space just a short stroll north of Oxford Circus, featuring a pretty rose garden and open air theatre.",
        imageUrl: "https://media.timeout.com/images/106198676/750/422/image.jpg",
        mapUrl: "https://www.google.com/maps/search/?api=1&query=Regent's+Park"
    },
    {
        name: "Young V&A",
        description: "Formerly the Museum of Childhood, it's home to one of the world’s finest collections of children’s toys, dolls’ houses and games.",
        imageUrl: "https://media.timeout.com/images/106198679/750/422/image.jpg",
        mapUrl: "https://www.google.com/maps/search/?api=1&query=Young+V%26A"
    },
    {
        name: "St James’s Park",
        description: "London’s oldest Royal Park and essentially Buckingham Palace’s front garden. See the famous pelicans being fed daily at 2.30pm.",
        imageUrl: "https://media.timeout.com/images/106198681/750/422/image.jpg",
        mapUrl: "https://www.google.com/maps/search/?api=1&query=St+James’s+Park"
    }
];

const MapPinIcon = () => ( <svg className="w-4 h-4 inline-block ml-1" fill="currentColor" viewBox="0 0 20 20"><path fillRule="evenodd" d="M5.05 4.05a7 7 0 119.9 9.9L10 18.9l-4.95-4.95a7 7 0 010-9.9zM10 11a2 2 0 100-4 2 2 0 000 4z" clipRule="evenodd" /></svg> );

function LondonAttractions() {
    const [visibleCount, setVisibleCount] = useState(12);

    const loadMore = () => {
        setVisibleCount(allAttractions.length);
    };

    return (
        <>
            <Helmet>
                <title>Top 50 Places to Visit in London for Indians (2026)</title>
                <meta 
                    name="description" 
                    content="50 must-see places in London for Indian students and families, from the Tower of London and Buckingham Palace to the British Museum, with tips for visitors."
                />
                {/* Social previews (WhatsApp, Facebook, X) — otherwise the homepage values are used */}
                <meta property="og:title" content="Top 50 Places to Visit in London for Indians (2026)" />
                <meta property="og:description" content="50 must-see places in London for Indian students and families, from the Tower of London and Buckingham Palace to the British Museum, with tips for visitors." />
                <meta name="twitter:title" content="Top 50 Places to Visit in London for Indians (2026)" />
                <meta name="twitter:description" content="50 must-see places in London for Indian students and families, from the Tower of London and Buckingham Palace to the British Museum, with tips for visitors." />
            </Helmet>

            <div className="container mx-auto p-6 bg-white dark:bg-gray-800 rounded-lg shadow-md my-6">
                <div className="max-w-5xl mx-auto text-left">
                    <h1 className="text-3xl md:text-4xl font-extrabold text-indigo-700 dark:text-indigo-300 mb-4 text-center">
                        Top Attractions in London
                    </h1>
                    <p className="text-lg text-gray-700 dark:text-gray-300 mb-12 text-center">
                        Welcome to London! Whether you're a student, professional, or just visiting, these iconic landmarks are the perfect way to experience the city's rich history and vibrant culture.
                    </p>

                    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
                        {allAttractions.slice(0, visibleCount).map((attraction, index) => (
                            <div key={index} className="bg-gray-50 dark:bg-slate-800 rounded-xl shadow-lg overflow-hidden flex flex-col transform hover:-translate-y-2 transition-transform duration-300">
                                <img src={attraction.imageUrl} alt={attraction.name} loading="lazy" decoding="async" className="w-full h-56 object-cover" />
                                <div className="p-6 flex flex-col flex-grow">
                                    <h3 className="font-bold text-xl text-indigo-700 dark:text-indigo-400 mb-2">{attraction.name}</h3>
                                    <p className="text-sm text-gray-600 dark:text-gray-400 flex-grow">{attraction.description}</p>
                                    <a 
                                        href={attraction.mapUrl} 
                                        target="_blank" 
                                        rel="noopener noreferrer" 
                                        className="text-indigo-500 hover:text-indigo-700 dark:hover:text-indigo-300 font-semibold text-sm mt-4 inline-flex items-center"
                                    >
                                        📍 View on Map
                                    </a>
                                </div>
                            </div>
                        ))}
                    </div>

                    {visibleCount < allAttractions.length && (
                        <div className="text-center mt-12">
                            <button
                                onClick={loadMore}
                                className="px-8 py-3 rounded-full bg-indigo-600 hover:bg-indigo-700 text-white font-bold text-lg transition duration-200 shadow-md transform hover:scale-105"
                            >
                                Show All Attractions
                            </button>
                        </div>
                    )}

                     <div className="bg-indigo-50 dark:bg-indigo-900/50 border-t border-indigo-200 dark:border-indigo-800 rounded-b-lg p-6 text-center mt-12">
                        <h2 className="text-2xl font-bold text-indigo-800 dark:text-indigo-200 mb-3">Living in London?</h2>
                        <p className="text-indigo-700 dark:text-indigo-300 mb-5">Once you're done exploring, find the perfect place to call home. Search for Indian flatmates and rooms across the city.</p>
                        <Link
                            to="/"
                            className="inline-flex items-center justify-center px-8 py-3 rounded-full bg-indigo-600 hover:bg-indigo-700 text-white font-bold text-lg transition duration-200 shadow-lg transform hover:scale-105"
                        >
                            Find a Flatmate
                        </Link>
                    </div>

                    <section className="mt-12">
                        <h2 className="text-2xl font-bold text-gray-800 dark:text-gray-200 mb-4">Tips for Visiting London's Attractions</h2>
                        <ul className="list-disc list-inside space-y-3 text-gray-600 dark:text-gray-400 pl-4">
                            <li><strong>Many top museums are free:</strong> the British Museum, National Gallery, Natural History Museum, Science Museum, V&amp;A and Tate Modern don't charge for entry. Special exhibitions usually need a paid ticket.</li>
                            <li><strong>Travel with contactless or Oyster:</strong> tap in and out on the Tube and tap once on buses. Daily fare caps mean you never pay more than a set amount in a day, and the bus Hopper fare lets you take unlimited bus journeys within an hour for one fare.</li>
                            <li><strong>Book paid attractions online:</strong> places like the Tower of London and the London Eye are often cheaper and quicker to enter when booked in advance.</li>
                            <li><strong>Check the Changing the Guard schedule:</strong> it doesn't happen every day all year, so check the official schedule before you go.</li>
                            <li><strong>Enjoy free views:</strong> the Sky Garden is free but needs booking ahead; Primrose Hill and Greenwich Park offer great skyline views at no cost.</li>
                            <li><strong>Be ready for the weather:</strong> London weather changes quickly, so carry a light waterproof even in summer.</li>
                            <li><strong>Indian food nearby:</strong> Drummond Street, near Euston, is known for its South Indian vegetarian restaurants and is close to the British Museum and King's Cross.</li>
                        </ul>
                    </section>

                    <FaqSection faqs={[
                        { q: "What are the top 5 must-see attractions in London for a first-time visitor?", a: "For a first-time visitor, the top 5 must-see attractions are the Tower of London (to see the Crown Jewels), the British Museum (for world history), Buckingham Palace (for the Changing of the Guard), the London Eye (for city views), and the Houses of Parliament with Big Ben." },
                        { q: "Are museums in London free for Indian tourists?", a: "Yes, many of London's best and most famous museums are completely free to enter for everyone, including tourists from India. This includes the British Museum, the National Gallery, the Natural History Museum, and the Science Museum. Special exhibitions may require a paid ticket." },
                    ]} />
                </div>
            </div>
        </>
    );
}

export default LondonAttractions;